import { Content } from './Content'
import { List } from './List'
import { Root } from './Root'
import { Tab } from './Tab'

export const Tabs = {
  Root,
  Content,
  Tab,
  List,
}
